import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { RequestFormService } from 'src/app/shared/service/requestForm/request-form.service';

@Component({
  selector: 'app-view-more',
  templateUrl: './view-more.component.html',
  styleUrls: ['./view-more.component.scss']
})
export class ViewMoreComponent {
constructor(@Inject(MAT_DIALOG_DATA) public data: any, private dialogRef: MatDialogRef<ViewMoreComponent>,private requestFormService: RequestFormService,) { }

  closeDialog() {
    this.dialogRef.close();
  }
  isDarkMode() {
    return this.requestFormService.isDarkMode();
  }
}
